module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Files/Locked-folder-adc3e108d6913233283987e5be452794.svg";